var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormButton',{ref:"button",staticClass:"report-tab-button",attrs:{"outline":""},on:{"click":_vm.reportTab}},[_c('i',{staticClass:"far fa-thumbs-down"}),_vm._v(" Докладвай ")])}
var staticRenderFns = []

export { render, staticRenderFns }